import type { Method } from 'lib/axios';
import { APICallV4 } from 'reactApp/api/APICall';

export class PrivateListAPICall extends APICallV4 {
    _method = 'private/list';
    _type: Method = 'get';
}
